import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import dateFns from 'date-fns';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TooltipOnHover from './TooltipOnHover';

var Timeago =
/*#__PURE__*/
function (_Component) {
  _inherits(Timeago, _Component);

  function Timeago(props) {
    var _this;

    _classCallCheck(this, Timeago);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Timeago).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "tick", function () {
      _this.setState(_this.computeDistance());

      clearTimeout(_this.timeout);

      if (_this.state.refresh) {
        _this.timeout = setTimeout(_this.tick, _this.state.refresh * 1000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "computeDistance", function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.date;
      var now = Date.now();
      var from = new Date(date).getTime();
      var diff = Math.floor((now - from) / 1000);

      if (diff < 60) {
        return {
          frame: 'second',
          count: diff,
          refresh: 14
        };
      } else if (diff < 3600) {
        // 1 hour
        return {
          frame: 'minute',
          count: Math.floor(diff / 60),
          refresh: 55
        };
      } else if (diff < 14400) {
        // 4 hours
        return {
          frame: 'hour',
          count: Math.floor(diff / 3600),
          refresh: 3400
        };
      } else if (dateFns.isToday(date)) {
        return {
          frame: 'today',
          count: Math.floor(diff / 3600),
          refresh: 3400
        };
      } else if (dateFns.isYesterday(date)) {
        return {
          frame: 'yesterday',
          count: Math.floor(diff / 3600),
          refresh: 3400
        };
      } else if (diff < 604800) {
        // A week
        return {
          frame: 'day',
          count: Math.floor(diff / 86400),
          refresh: null
        };
      } else if (diff < 2592000) {
        // A month
        return {
          frame: 'week',
          count: Math.floor(diff / 604800),
          refresh: null
        };
      } else if (diff < 31536000) {
        // A year
        return {
          frame: 'month',
          count: Math.floor(diff / 2592000),
          refresh: null
        };
      }

      return {
        frame: 'date',
        count: Math.floor(diff / 3600),
        refresh: null
      };
    });

    _this.state = _this.computeDistance(props.date);
    return _this;
  }

  _createClass(Timeago, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.date !== this.props.date || this.state.frame !== nextState.frame || this.state.count !== nextState.count;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tick();
    } // TODO: Change me to getDerivedStateFromProps
    // eslint-disable-next-line react/no-deprecated

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.setState(this.computeDistance(props.date));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "getFormattedDate",
    value: function getFormattedDate() {
      var frame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.frame;
      var _this$props = this.props,
          date = _this$props.date,
          lowercase = _this$props.lowercase,
          formatToday = _this$props.formatToday;

      switch (frame) {
        case 'second':
          return 'few moments ago';

        case 'minute':
          return React.createElement(FormattedMessage, {
            id: "time.minutes",
            defaultMessage: "{count, plural,\n            one {a minute ago}\n            other {# minutes ago}\n          }",
            values: {
              count: this.state.count
            }
          });

        case 'hour':
          return React.createElement(FormattedMessage, {
            id: "time.hours",
            defaultMessage: "{count, plural,\n            one {an hour ago}\n            other {# hours ago}\n          }",
            values: {
              count: this.state.count
            }
          });

        case 'today':
          return formatToday ? formatToday(date) : lowercase ? "today" : "Today";

        case 'yesterday':
          return lowercase ? "yesterday" : "Yesterday";

        case 'day':
          return React.createElement(FormattedMessage, {
            id: "time.days",
            defaultMessage: "{count, plural,\n            one {a day ago}\n            other {# days ago}\n          }",
            values: {
              count: this.state.count
            }
          });

        case 'week':
          return React.createElement(FormattedMessage, {
            id: "time.weeks",
            defaultMessage: "{count, plural,\n            one {a week ago}\n            other {# weeks ago}\n          }",
            values: {
              count: this.state.count
            }
          });

        case 'month':
          return React.createElement(FormattedMessage, {
            id: "time.months",
            defaultMessage: "{count, plural,\n            one {a month ago}\n            other {# months ago}\n          }",
            values: {
              count: this.state.count
            }
          });

        default:
          return dateFns.format(date, 'MMMM, Do YYYY, h:mm A');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dateElement = React.createElement("span", null, this.getFormattedDate());

      if (this.state.frame === 'date') {
        return dateElement;
      }

      return React.createElement(TooltipOnHover, {
        id: "timeago",
        delayShow: 1000,
        placement: "top",
        tooltipContent: this.getFormattedDate('date')
      }, dateElement);
    }
  }]);

  return Timeago;
}(Component);

_defineProperty(Timeago, "propTypes", {
  date: PropTypes.string.isRequired,
  lowercase: PropTypes.bool,
  formatToday: PropTypes.func
});

export default Timeago;